
(async function initPlatformeIntegration() {
  const model = document.querySelector('[data-platforme-model]').dataset.platformeModel
  const productType = document.querySelector('[data-platforme-model]').dataset.platformeProductType
  const mainImage = document.querySelector('[data-platforme-main-image]')
  const bodyColorSwatchesWrapper = document.querySelector('[data-platforme-body-color]')
  const lettersSwatchesWrapper = document.querySelector('[data-platforme-letters]')
  const letterColorSwatchesBlock = document.querySelector('[data-platforme-letter-swatches]')
  const letterColorSwatchesWrapper = document.querySelector('[data-platforme-letter-color]')
  const lettersSelected = document.querySelectorAll('[data-platforme-letter-selected]')
  const clearLettersBtn = document.querySelector('[data-platforme-clear-letters]')
  const configurator3d = document.querySelector('[data-platforme-3d]')
  const priceWrapper = document.querySelector('[data-platforme-price] .money')
  const cartBtn = document.querySelector('[data-platforme-cart-btn]')
  const letterErrors = document.querySelector('[data-platforme-disabled-msg]')
  const standardVersionLink = document.querySelector('[data-platforme-standard-version-link]')
  const startingColor = location.hash?.replace('#', '');

  // console.log('platformeLetterProducts', platformeLetterProducts)

  const platformeBaseProductsColors = platformeBaseProducts.map(prod => prod.color)

  const ripeParams = {
    url: 'https://ripe-core.platforme.com/api/', // <- tests purposes only - Production URL: https://app.platforme.com/api/
    platformeIdToken: 'PLATFORME_ID_GENERATED_TOKEN_HERE', // <- change to value from generating a new token in https://id.platforme.com/me/tokens
    brand: 'akris',
    model,
    options: {
      format: 'webp',
      errorPopup: false,
      remoteCalls: false,
      useMasks: false,
      usePrice: false,
      useSync: false,
    },
  };

  // Init a RIPE SDK instance for the desired config
  window.ripeSdk = new Ripe({ url: ripeParams.url });

  await window.ripeSdk.config(
    ripeParams.brand,
    ripeParams.model,
    ripeParams.options
  );

  // Bind the initialsImage to our RIPE config
  // +info: https://github.com/ripe-tech/ripe-sdk#5-product-personalization
  window.ripeSdk.bindImage(mainImage, {
    frame: (productType === 'bag') ? 'letter' : 'top',
    width: 1000,
    height: 1000,
  });

  if (productType === 'bag') {
    window.configurator = window.ripeSdk.bindConfigurator(configurator3d, {
      width: 1000, // width of the frame
      height: 1000, // height of the frame
    });
  }

  const choices = await window.ripeSdk.getChoices();

  let bodyColors;
  switch (productType) {
    case 'bag':
      bodyColors = Object.entries(choices.bag.materials.cervocalf_leather.colors)
        .filter(([_colorName, {available}]) => available)
        .filter(([colorName, _v]) => platformeBaseProductsColors.includes(colorName))
        .map(([colorName, _v]) => colorName)
      break;
    case 'strap':
      bodyColors = Object.entries(choices.strap.materials.cervocalf_leather.colors)
        .filter(([_colorName, {available}]) => available)
        .filter(([colorName, _v]) => platformeBaseProductsColors.includes(colorName))
        .map(([colorName, _v]) => colorName)
      break;
    default:
      break;
  }

  const letters = Object.entries(choices.first_letter.materials)
    .filter(([_letter, {available}]) => available)
    .map(([letter, _v]) => letter)

  const letterColors = Object.entries(choices.first_letter.materials.a.colors)
    .filter(([_colorName, {available}]) => available)
    .map(([colorName, _v]) => colorName)


  let uiState = {
    body: startingColor || bodyColors[0] || null,
    letters: []
  }
  standardVersionLink && (standardVersionLink.href = platformeBaseProducts.find(el => el.color === uiState.body || 'black').url)

  addEventListener('hashchange', e => {
    window.scrollTo(0, 0)
    const color = location.hash?.replace('#', '');
    const bodyColorRadios = document.querySelectorAll('input[type="radio"][name="body"]')
    bodyColorRadios.forEach(r => {
      r.value === color ? (r.checked = true) : (r.checked = false)
    })
    uiState = {...uiState, body: color}
    updateParts()
  })

  clearLettersBtn.addEventListener('click', e => {
    e.preventDefault()
    uiState = { ...uiState, letters: [] }

    lettersSelected.forEach((el, i) => {
      if (i == 0) {
        el.className = 'platforme-product__letter-selection active'
      } else {
        el.className = 'platforme-product__letter-selection'
      }
      el.textContent = i + 1
    })

    document.querySelectorAll('input[type="radio"][name="letter"]').forEach(r => r.disabled = false)
    document.querySelectorAll('input[type="radio"][name="letterColor"]').forEach(r => r.disabled = false)

    updateParts()
  })

  cartBtn.addEventListener('click', async function(e) {
    e.preventDefault()
    addProductsToCart()
  })
  
  populateSwatches(bodyColorSwatchesWrapper, bodyColors, 'body')
  populateLetters(lettersSwatchesWrapper, letters, 'letter')
  populateSwatches(letterColorSwatchesWrapper, letterColors, 'letterColor')

  document.querySelectorAll('input[type="radio"][name="body"]').forEach(r => r.addEventListener('change', e => {
    uiState = {...uiState, body: e.target.value}
    updateParts()
  }))

  document.querySelectorAll('input[type="radio"][name="letter"]').forEach(l => l.addEventListener('change', e => {
    const isLetterSelected = [...document.querySelectorAll('input[type="radio"][name="letter"]')].filter(r => r.checked === true).length > 0
    if (isLetterSelected) {
      letterColorSwatchesBlock.style.display = 'block'
    } else {
      letterColorSwatchesBlock.style.display = 'none'
    }
  }))

  document.querySelectorAll('input[type="radio"][name="letterColor"]').forEach(r => r.addEventListener('change', e => {
    const curLetter = document.querySelector('input[type="radio"][name="letter"]:checked').value
    const curLetterColor = e.target.value
    uiState = {...uiState, letters: [...uiState.letters, { letter: curLetter, color: curLetterColor }]}

    const letterToFill = lettersSelected[uiState.letters.length - 1]
    letterToFill.textContent = curLetter
    letterToFill.classList.add(curLetterColor)
    letterToFill.nextElementSibling && letterToFill.nextElementSibling.classList.add('active')
    // letterToFill.nextElementSibling && (letterToFill.nextElementSibling.textContent = '')

    document.querySelectorAll('input[type="radio"][name="letter"]').forEach(r => r.checked = false)
    document.querySelectorAll('input[type="radio"][name="letterColor"]').forEach(r => r.checked = false)

    if (uiState.letters.length === 3) {
      document.querySelectorAll('input[type="radio"][name="letter"]').forEach(r => r.disabled = true)
      document.querySelectorAll('input[type="radio"][name="letterColor"]').forEach(r => r.disabled = true)
    }

    letterColorSwatchesBlock.style.display = 'none'
    
    updateParts()
  }))

  updateParts()

  function populateSwatches(wrapper, options, name) {
    const radios = options.map((o, i) => {
      let checked = ''
      if (name === 'body' && !startingColor && i === 0) {
        checked = ' checked'
      }
      if (name === 'body' && startingColor === o) {
        checked = ' checked'
      }
      return `<div class="color-swatch ${o}">
        <input type="radio" value="${o}" id="${name}_${o}" name="${name}"${checked}>
        <label title="${o.replaceAll('_', ' ')}" for="${name}_${o}"></label>
      </div>`
    })
    wrapper.innerHTML = radios.join('')
  }

  function populateLetters(wrapper, options, name) {
    const radios = options.map((o, i) => `
      <div class="letter-swatch ${o}">
        <input type="radio" value="${o}" id="${name}_${o}" name="${name}">
        <label for="${name}_${o}">${o}</label>
      </div>
    `)
    wrapper.innerHTML = radios.join('')
  }

  async function updateParts() {
    // cartBtn.disabled = (productType === 'bag') ? uiState.letters.length === 1 || uiState.body === null : uiState.letters.length < 2 || uiState.body === null
    cartBtn.disabled = uiState.letters.length < 2 || uiState.body === null
    // letterErrors.classList.toggle('hidden', (productType === 'bag') ? uiState.letters.length !== 1 : uiState.letters.length >= 2)
    letterErrors.classList.toggle('hidden', uiState.letters.length >= 2)
    
    // get URL of the standard version
    standardVersionLink && (standardVersionLink.href = platformeBaseProducts.find(el => el.color === uiState.body).url)
    
    await window.ripeSdk.setParts([
      [
        productType,
        'cervocalf_leather',
        uiState.body || 'black'
      ],
      [
        'first_letter',
        uiState.letters[0]?.letter || null,
        uiState.letters[0]?.color || null,
      ],
      [
        'second_letter',
        uiState.letters[1]?.letter || null,
        uiState.letters[1]?.color || null,
      ],
      [
        'third_letter',
        uiState.letters[2]?.letter || null,
        uiState.letters[2]?.color || null,
      ],
    ])


    updatePrice()
  }

  async function updatePrice() {
    const currentSkusRemote = await window.ripeSdk.runLogicP({
      method: "parts_to_skus",
      dataJ: {
        parts: window.ripeSdk.parts,
      },
    });

    const prices = currentSkusRemote.map((sku, i) => {
      return (i === 0) ? platformeBaseProducts.find(prod => prod.sku === sku).price : platformeLetterProducts.find(prod => prod.sku === sku).price
    })
    const totalPrice = prices.reduce((acc, curr) => acc += curr, 0)
    priceWrapper.textContent = Shopify.formatMoney(totalPrice)
  }

  async function addProductsToCart() {
    const currentSkusRemote = await window.ripeSdk.runLogicP({
      method: "parts_to_skus",
      dataJ: {
        parts: window.ripeSdk.parts,
      },
    });

    const customProdId = `custom-${Date.now()}`
    const itemsForCart = [...currentSkusRemote].reverse().map((sku, i, arr) => ({
      quantity: 1,
      id: (i === arr.length - 1) ? platformeBaseProducts.find(prod => prod.sku === sku).id : platformeLetterProducts.find(prod => prod.sku === sku).id
    }))

    if (uiState.letters.length > 1) {
      itemsForCart.forEach(item => item.properties = {
        _customProdId: customProdId
      })

      const {first_letter, second_letter, third_letter} = window.ripeSdk.parts
    
      itemsForCart[itemsForCart.length - 1].properties.letters = `${first_letter.material}/${first_letter.color} - ${second_letter.material}/${second_letter.color}`
      third_letter && (itemsForCart[itemsForCart.length - 1].properties.letters += ` - ${third_letter.material}/${third_letter.color}`)
    }
    
    console.log('itemsForCart', itemsForCart)
    
    const payload = {
      items: itemsForCart
    }

    const addToCartRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(res => res.json())

    await fetch(location.href).then(res => res.text()).then(page => updateAjaxCart(page))
  }

  function updateAjaxCart(data) {
    var $html = $(data);
    var cartCount = $html.find(".cart-count").text();
    var $itemsHTML = $html.find(".header .cart__holder");
    var $cartDrawer = $(".cart-drawer__form");
    $(".cart-count").text(cartCount);
    $cartDrawer.find(".cart__holder").remove();
    $cartDrawer.append($itemsHTML);
    $(".cart-item").addClass("active");
  }
})();